module.exports = __webpack_public_path__ + "img/individual-meter-gas-meter-md.eb993990.svg";